import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  TabContent,
  TabPane,
} from "reactstrap";
import CommentListByPostId from "./components/CommentListByPostId";

export interface Props {
  item?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
}

registerLocale("en", en);
registerLocale("ko", ko);

const CommentDetailModal = ({ item, triggerRefresh, onClose }: Props) => {
  const { t } = useTranslation();
  
  const onCloseClick = () => {
    onClose && onClose();
  };

  return (
    <Modal isOpen={true} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{`${t("Comment Detail")} ${item?.title ? '-'  : ""} ${item?.title || ""}` }</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }}>
          <Col lg={12}>
            <Card
              id="ACCOUNT_INFO"
              style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
            >
              <TabContent activeTab={"ACCOUNT_INFO"}>
                <TabPane tabId="ACCOUNT_INFO">
                  <CommentListByPostId item={item} triggerRefreshCommunity={triggerRefresh} />
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CommentDetailModal;
